var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("ReceiptsFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c(
        "div",
        {
          staticClass:
            "text-left mb-2 d-flex justify-content-start align-items-center"
        },
        [
          _vm.filteredReceipts.length
            ? _c(
                "div",
                { staticClass: "my-2 text-primary" },
                [
                  _c("b-form-checkbox", {
                    staticClass: "d-inline-block",
                    on: { change: _vm.selectAllReceipts },
                    model: {
                      value: _vm.selectAll,
                      callback: function($$v) {
                        _vm.selectAll = $$v
                      },
                      expression: "selectAll"
                    }
                  }),
                  _vm._v(" Seleccionar todos ")
                ],
                1
              )
            : _vm._e(),
          _vm.selectedReceipts.length
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED183",
                      expression: "'ED183'"
                    }
                  ],
                  staticClass: "ml-4 badge-glow",
                  attrs: { variant: "primary", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.invoiceMassiveReceipts()
                    }
                  }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-3",
                    attrs: { icon: "DownloadIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v("Facturar")
                  ])
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-button",
            {
              staticClass: "ml-4 badge-glow",
              attrs: { variant: "warning", size: "sm" },
              on: { click: _vm.onDownloadReceipts }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-3",
                attrs: { icon: "DownloadIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Descargar")])
            ],
            1
          )
        ],
        1
      ),
      _c("ReceiptsHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.filteredReceipts, function(receipt) {
          return _c("ReceiptRow", {
            key: receipt.comprobanteId,
            attrs: {
              "is-massive": _vm.isMassive,
              "selected-receipts": _vm.selectedReceipts,
              receipt: receipt,
              "select-receipt": _vm.selectReceipt
            },
            on: {
              "select-check-receipt": _vm.selectCheckReceipt,
              "unselect-check-receipt": _vm.unSelectCheckReceipt,
              "reload-list": _vm.handleReloadList
            }
          })
        }),
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.fetchReceipts()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v("10")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("ReceiptsPagination", {
              attrs: { show: _vm.filteredReceipts.length },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "receipts-invoice",
          attrs: {
            id: "receipts-invoice",
            title: "Facturar Comprobantes",
            "hide-footer": ""
          }
        },
        [
          _c("ReceiptsInvoice", {
            attrs: { receipts: _vm.selectedReceipts },
            on: { invoice: _vm.handleOnInvoice }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }